module.exports = __webpack_public_path__ + "static/media/download-link-qr-code-play-store.23d2a4f3.png";